
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","id":"Check-Double-1--Streamline-Streamline-3.0","height":"24","width":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('desc',[_v('Check Double 1 Streamline Icon: https://streamlinehq.com')]),_c('g',[_c('path',{attrs:{"d":"M23.22 2.06a1.49 1.49 0 0 0 -2 0.59l-8.5 15.43 -6.26 -6.79a1.5 1.5 0 1 0 -2.21 2l7.64 8.34a1.52 1.52 0 0 0 2.42 -0.29l9.5 -17.24a1.5 1.5 0 0 0 -0.59 -2.04Z","fill":"currentColor","stroke-width":"1"}}),_c('path',{attrs:{"d":"M2.61 14.63a1.5 1.5 0 0 0 -2.22 2l4.59 5a1.52 1.52 0 0 0 2.11 0.09 1.49 1.49 0 0 0 0.1 -2.12Z","fill":"currentColor","stroke-width":"1"}}),_c('path',{attrs:{"d":"M10.3 13a1.41 1.41 0 0 0 2 -0.54l4.59 -8.36a1.5 1.5 0 1 0 -2.62 -1.45L9.68 11a1.41 1.41 0 0 0 0.62 2Z","fill":"currentColor","stroke-width":"1"}})])])
          )
        }
      }
    